import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const useStyles = makeStyles(({
	portlet: {
		margin: "20px 0"
	},
	bodyText: {
		fontSize: "18px",
		textAlign: "center"
	},
	bodySubtext: {
		fontSize: "18px",
		textAlign: "center",
		marginBottom: "20px"
	},
	button: {
		margin: "30px auto",
		...ColorUtil.getBackgroundAndContrastColor(themeColors.colors.base.white),
		width: "300px",
		padding: "18px 40px",
		borderRadius: "50px",
		color: themeColors.getPrimaryColor()
	},
	calloutTitle: {
		fontSize: "40px",
		color: themeColors.getPrimaryColor(),
		fontWeight: 600,
		lineHeight: "normal",
		marginBottom: "20px"
	},
	calloutImage: {
		width: "-webkit-fill-available"
	},
	stageContainer: {
		marginTop: "5px",
		...ColorUtil.getBackgroundAndContrastColor(themeColors.getPrimaryColor()),
		color: themeColors.colors.base.white,
		borderRadius: "20px",
		alignItems: "center",
		height: "100%",
		justifyContent: "flex-start",
		padding: "10px 20px"
	},
	stageTitle: {
		fontWeight: "bold",
		color: themeColors.colors.base.white,
		fontSize: "24px",
		textAlign: "center",
		lineHeight: 1
	},
	sectionTitle: {
		fontWeight: "bold",
		textAlign: "center",
		fontSize: "32px",
		color: colors.gray[900],
		marginTop: "30px"
	},
	sectionSubtitle: {
		fontWeight: "bold",
		textAlign: "center",
		fontSize: "20px",
		color: colors.gray[900]
	},
	stageDescription: {
		textAlign: "center",
		color: themeColors.colors.base.white
	},
	stageIconSize: {
		fontSize: "40px"
	},
	stageIconRotated: {
		fontSize: "40px",
		transform: "rotate(-90deg)"
	},
	tableContainer: {
		...ColorUtil.getBackgroundAndContrastColor(themeColors.colors.base.white),
		borderRadius: "30px",
		overflow: "hidden",
		padding: "30px"
	},
	tableHeaderCell: {
		borderBottom: `2px solid ${colors.gray[300]}`,
		padding: "20px 16px",
		textAlign: "center"
	},
	tableBenefitsColumnHeader: {
		fontWeight: "bold",
		color: colors.gray[900]
	},
	levelIcon: {
		fontSize: "30px",
		width: "30px",
		height: "30px",
		"& svg": {
			width: "100%",
			height: "100%"
		}
	},
	levelName: {
		fontWeight: "bold"
	},
	silverLevelColor: {
		color: colors.gray[400]
	},
	goldLevelColor: {
		color: themeColors.colors.system.yellow[300]
	},
	diamondLevelColor: {
		color: themeColors.colors.system.blue[500]
	},
	tableBenefitCell: {
		padding: "20px 16px",
		borderBottom: `1px solid ${colors.gray[200]}`
	},
	tableBenefitName: {
		fontWeight: "bold",
		color: colors.gray[900],
		marginBottom: "4px"
	},
	tableBenefitDescription: {
		color: colors.gray[600],
		fontSize: "14px"
	},
	tableBenefitAvailableIcon: {
		color: themeColors.colors.system.green[600],
		fontSize: "25px"
	},
	tableBenefitUnavailableIcon: {
		color: themeColors.colors.system.red[400],
		fontSize: "25px"
	},
	tableBenefitCustomText: {
		color: colors.gray[900],
		fontSize: "14px",
		textAlign: "center"
	},
	participationReasonCard: {
		border: `1px solid ${themeColors.getPrimaryColor()}`,
		borderRadius: "30px",
		justifyContent: "center",
		alignItems: "center",
		padding: "10px",
		height: "100%"
	},
	participationReasonText: {
		color: themeColors.getPrimaryColor(),
		fontWeight: "bold",
		textAlign: "center",
		fontSize: "18px",
		lineHeight: 1.2
	},
	channelSectionOuter: {
		...ColorUtil.getBackgroundAndContrastColor(colors.green[100]),
		borderRadius: "30px",
		padding: "40px 20px"
	},
	channelSectionInner: {
		...ColorUtil.getBackgroundAndContrastColor(themeColors.colors.base.white),
		borderRadius: "30px",
		padding: "30px 20px"
	},
	whatsappLogo: {
		width: "50px",
		marginBottom: "20px"
	},
	channelTitle: {
		fontSize: "30px",
		fontWeight: "bold",
		color: colors.gray[900],
		textAlign: "center",
		marginBottom: "30px",
		lineHeight: 1
	},
	channelButton: {
		...ColorUtil.getBackgroundAndContrastColor("#00B465"),
		color: themeColors.colors.base.white,
		padding: "14px 32px",
		borderRadius: "50px",
		fontWeight: "bold",
		fontSize: "16px",
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor("#009E50")
		}
	}
}))

export default useStyles
